import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    accordianLink: Object.assign(Object.assign(Object.assign({}, (theme.isFlyingFlowers ? theme.typography.medium_regular : theme.typography.small_regular)), (theme.isFlyingFlowers ? theme.typographySpacing.medium_regular_sm : theme.typographySpacing.small_regular_sm)), { color: colors.supplementary.black, textDecoration: 'none', display: 'inline-block', transition: 'color 0.2s ease', '&:hover': {
            color: colors.grey.grey6,
            textDecoration: 'underline',
            cursor: 'pointer',
        }, [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.medium_regular), theme.typographySpacing.medium_regular_sm) }),
    accordianSummaryContent: Object.assign(Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.small_bold_sm), { color: colors.supplementary.black, textDecoration: 'none', cursor: 'pointer', transition: 'color 0.2s ease', margin: '12px 0', '&:hover': {
            color: colors.grey.grey6,
            textDecoration: 'underline',
        }, '&.Mui-expanded': {
            // Required to override MUI AccordionSummary expanded margin (20px 0)
            margin: `12px 0 ${spacing.xs} 0 !important`,
            color: colors.supplementary.black,
            textDecoration: 'none',
            '&:hover': {
                color: colors.grey.grey6,
                textDecoration: 'underline',
            },
            '& h3,h1,h2,h4': {
                textDecoration: 'inherit',
                margin: '0px',
            },
        }, '& h3,h1,h2,h4': Object.assign(Object.assign(Object.assign({ margin: '0px' }, theme.typography.small_bold), theme.typographySpacing.none), { color: 'inherit', textDecoration: 'inherit' }) }),
    accordianSummaryRoot: {
        flexDirection: 'row-reverse',
        // Required to override MUI AccordionSummary default 16px horizontal padding (padding: 0 16px)
        padding: '0 !important',
        minHeight: '52px !important',
        '&:hover .MuiAccordionSummary-content': {
            color: colors.grey.grey6,
            textDecoration: 'underline',
        },
        '&.Mui-expanded': {
            minHeight: `${spacing.xl} !important`,
        },
        width: '100%',
    },
    accordianAnswer: Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.none), { color: theme.isFlyingFlowers ? colors.black[700] : colors.grey.grey6, '& > p': Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.none), { 
            // Required to override default paragraph bottom margin in RawHtml
            marginBottom: `${spacing.xs} !important` }), '& ul': { marginTop: '0px', marginBottom: spacing.xs }, '& ul li': Object.assign({}, theme.typography.small_regular), '& a': {
            color: theme.isFlyingFlowers ? undefined : colors.primary.gold5,
        }, [theme.breakpoints.up('md')]: Object.assign(Object.assign({ '& p': Object.assign({}, (theme.isFlyingFlowers ? theme.typography.small_regular : undefined)), '& ul li': Object.assign({}, (theme.isFlyingFlowers ? theme.typography.small_regular : undefined)) }, (theme.isFlyingFlowers ? theme.typography.small_regular : undefined)), (theme.isFlyingFlowers ? theme.typographySpacing.none : undefined)) }),
    accordianDetailsRoot: {
        // Required to override MUI AccordionDetails default padding (8px 16px 16px)
        padding: '0 12px 12px 28px !important',
    },
    accordian: {
        color: colors.grey.grey6,
        boxSizing: 'border-box',
        borderBottom: `1px solid ${colors.grey.grey3}`,
        // Required to override MUI Paper/Accordion default padding
        paddingLeft: '0 !important',
        // Required to override MUI Accordion rounded corners
        borderBottomLeftRadius: '0 !important',
        borderBottomRightRadius: '0 !important',
        boxShadow: 'none',
        backgroundColor: 'unset',
        // Required to override MUI Accordion default expanded margin (16px 0)
        margin: '0 !important',
        '&:before': { backgroundColor: 'unset' },
        // Required to remove divider on the last expanded item
        '&.Mui-expanded:last-child': {
            borderBottom: `1px solid ${colors.grey.grey3} !important`,
        },
        '&.MuiAccordion-root.Mui-expanded': { margin: `0 0 ${spacing.xs}` },
    },
    accordianSummaryExpandIcon: {
        color: colors.supplementary.black,
        transition: 'transform 0.3s ease',
        transform: 'rotate(0deg)',
        marginRight: spacing.small,
        padding: 0,
        '&.Mui-expanded': {
            transform: 'rotate(180deg)',
            color: colors.supplementary.black,
        },
    },
    expandIcon: {
        fontSize: spacing.medium,
        color: colors.supplementary.black,
    },
}));
export default useStyles;
